import {
  type CommandConstructor,
  type CommandProperties
} from '@canvas/rovo-content-bridge-api';

import { type RovoContentBridgeAPIShape } from './rovo-bridge-types.ts';

interface PendingEvent {
  command: CommandConstructor;
  params: CommandProperties;
}

class BridgeEventEmitter {
  private pendingEvents: PendingEvent[] = [];
  private bridge: RovoContentBridgeAPIShape | null = null;

  initBridge = (bridge: RovoContentBridgeAPIShape) => {
    this.bridge = bridge;
    this.pendingEvents.forEach((event) => {
      bridge.send(event.command, event.params);
    });
    this.pendingEvents = [];
  };

  reset = () => {
    this.bridge = null;
  };

  sendEvent = (command: CommandConstructor, params: CommandProperties) => {
    if (this.bridge) {
      this.bridge.send(command, params);
    } else {
      this.pendingEvents.push({ command, params });
    }
  };
}

export const bridgeEventEmitter = new BridgeEventEmitter();
